export const filterProps = [
  "vyrez_bampera",
  "tip_kryuka",
  "elektrika_v_komplekte",
  "proizvoditel",
  "kol_vo_kontaktov",
  "kolicestvo_velosipedov",
  "tsvet_1",
  "tip_dugi",
  "tip_krepleniya",
];

export const filterSliderProps = [
  "price",
  "vertikalnaya_nagruzka",
  "tyagovaya_nagruzka_kg",
];
